import Icon from '../../components/Icon.vue'

Icon.register({"brands/uikit":{"width":448,"height":512,"paths":[{"d":"M443.9 128V384L218 512 0 384V169.7L87.6 214.8V331.8L221.1 407.3 356.9 331.8V180.8L255.8 123.2 343.4 70.1 443.9 128zM308.6 49.1L223.8 0 135.2 54.8 221.2 102.1 308.6 49.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/uikit.js
// module id = null
// module chunks = 